
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/user-area",
      function () {
        return require("private-next-pages/user-area/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/user-area"])
      });
    }
  